/**
 * Which Spacetime view a user gets. Full shows every tab; the restricted modes each collapse
 * Spacetime down to a single tab and are backed by their own mutually-exclusive license
 * (SFMC → SpacetimeSFMCOnly, Curacity → SpacetimeCuracityOnly).
 *
 * Lives apart from LicenseService so the pure view config can consume it without pulling the
 * service's Angular dependency graph in behind it.
 */
export enum SpacetimeMode {
    Full = 'full',
    SFMC = 'sfmc',
    Curacity = 'curacity',
}
